import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Comment as CommentIcon, Stack as StackIcon } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import classNames from "classnames";
import pluralize from "pluralize";
import { memo, useMemo } from "react";
export const AssetMetaData = /*#__PURE__*/ memo((param)=>{
    let { assetVersionCount, onCommentsClick, onVersionsClick, openCommentCount, shouldShowDiscussions, shouldShowVersions, pagesCount } = param;
    const showVersions = shouldShowVersions && assetVersionCount > 1;
    const showDiscussions = shouldShowDiscussions && openCommentCount > 0;
    const pagesCountText = useMemo(()=>{
        if (!pagesCount) {
            return "";
        }
        const textToShow = pluralize("page", pagesCount, true);
        return showVersions || showDiscussions ? "\xb7 ".concat(textToShow) : textToShow;
    }, [
        pagesCount,
        showDiscussions,
        showVersions
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("pointer-events-none flex items-center gap-1", showVersions || showDiscussions ? "-ml-1" : ""),
        children: [
            showVersions && /*#__PURE__*/ _jsx(Button, {
                appearance: "ghost",
                className: classNames("h-5 px-1", !!onVersionsClick ? "pointer-events-auto" : "pointer-events-none"),
                color: "grey",
                "data-disableselect": "true",
                "data-testid": "TABLE_ROW_VERSIONS_INDICATOR",
                onClick: (event)=>{
                    event.preventDefault();
                    onVersionsClick === null || onVersionsClick === void 0 ? void 0 : onVersionsClick();
                },
                /**
             * Prevents the button from triggering selection of the row when clicking on the button.
             */ onMouseDown: (event)=>event.stopPropagation(),
                prefix: /*#__PURE__*/ _jsx(StackIcon, {
                    className: "size-3"
                }),
                size: "small",
                children: assetVersionCount
            }),
            showDiscussions && /*#__PURE__*/ _jsx(Button, {
                appearance: "ghost",
                className: classNames("h-5 px-1", !!onCommentsClick ? "pointer-events-auto" : "pointer-events-none"),
                color: "grey",
                "data-disableselect": "true",
                "data-testid": "TABLE_ROW_DISCUSSIONS_INDICATOR",
                onClick: (event)=>{
                    event.preventDefault();
                    onCommentsClick === null || onCommentsClick === void 0 ? void 0 : onCommentsClick();
                },
                /**
             * Prevents the button from triggering selection of the row when clicking on the button.
             */ onMouseDown: (event)=>event.stopPropagation(),
                prefix: /*#__PURE__*/ _jsx(CommentIcon, {
                    className: "size-3"
                }),
                size: "small",
                children: openCommentCount
            }),
            !!pagesCountText && /*#__PURE__*/ _jsx("p", {
                className: "text-12",
                children: pagesCountText
            })
        ]
    });
});
AssetMetaData.displayName = "AssetMetaData";
